import { render, staticRenderFns } from "./CreateJob.vue?vue&type=template&id=fc0106fa&"
import script from "./CreateJob.vue?vue&type=script&lang=js&"
export * from "./CreateJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc0106fa')) {
      api.createRecord('fc0106fa', component.options)
    } else {
      api.reload('fc0106fa', component.options)
    }
    module.hot.accept("./CreateJob.vue?vue&type=template&id=fc0106fa&", function () {
      api.rerender('fc0106fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-add/component/CreateJob.vue"
export default component.exports